[
  {
    "code": "IE-L-CW",
    "name": "Carlow"
  },
  {
    "code": "IE-U-CN",
    "name": "Cavan"
  },
  {
    "code": "IE-M-CE",
    "name": "Clare"
  },
  {
    "code": "IE-M-CK",
    "name": "Cork"
  },
  {
    "code": "IE-U-DL",
    "name": "Donegal"
  },
  {
    "code": "IE-L-DN",
    "name": "Dublin"
  },
  {
    "code": "IE-C-GY",
    "name": "Galway"
  },
  {
    "code": "IE-M-KY",
    "name": "Kerry"
  },
  {
    "code": "IE-L-KE",
    "name": "Kildare"
  },
  {
    "code": "IE-L-KK",
    "name": "Kilkenny"
  },
  {
    "code": "IE-L-LS",
    "name": "Laois"
  },
  {
    "code": "IE-C-LM",
    "name": "Leitrim"
  },
  {
    "code": "IE-M-LK",
    "name": "Limerick"
  },
  {
    "code": "IE-L-LD",
    "name": "Longford"
  },
  {
    "code": "IE-L-LH",
    "name": "Louth"
  },
  {
    "code": "IE-C-MO",
    "name": "Mayo"
  },
  {
    "code": "IE-L-MH",
    "name": "Meath"
  },
  {
    "code": "IE-U-MN",
    "name": "Monaghan"
  },
  {
    "code": "IE-L-OY",
    "name": "Offaly"
  },
  {
    "code": "IE-C-RN",
    "name": "Roscommon"
  },
  {
    "code": "IE-C-SO",
    "name": "Sligo"
  },
  {
    "code": "IE-M-TY",
    "name": "Tipperary"
  },
  {
    "code": "IE-M-WD",
    "name": "Waterford"
  },
  {
    "code": "IE-L-WH",
    "name": "Westmeath"
  },
  {
    "code": "IE-L-WX",
    "name": "Wexford"
  },
  {
    "code": "IE-L-WW",
    "name": "Wicklow"
  }
]